import { useState } from 'react';
import { ChevronRight, ShoppingBag, XCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const MeusPedidos = () => {
  const [activeTab, setActiveTab] = useState('todos');

  const statusMessages = {
    todos: {
      title: 'Nenhum pedido encontrado',
      description: 'Você não possui nenhum pedido registrado'
    },
    processando: {
      title: 'Nenhum pedido em processamento',
      description: 'Você não possui pedidos sendo processados no momento'
    },
    enviados: {
      title: 'Nenhum pedido enviado',
      description: 'Você não possui pedidos em transporte no momento'
    },
    entregues: {
      title: 'Nenhum pedido entregue',
      description: 'Você não possui pedidos finalizados no momento'
    },
    cancelados: {
      title: 'Nenhum pedido cancelado',
      description: 'Você não possui pedidos cancelados no momento'
    }
  };

  const orders = {
    todos: [
      {
        id: '12345',
        date: '15/04/2024',
        status: 'processando',
        product: 'Smartphone XYZ Pro',
        price: 'R$ 2.499,00',
        quantity: 1,
        payment: 'Cartão de crédito',
        delivery: '20/04/2024',
        type: 'Entrega expressa'
      },
      {
        id: '12346',
        date: '16/04/2024',
        status: 'enviados',
        product: 'Fone Bluetooth',
        price: 'R$ 299,90',
        quantity: 2,
        payment: 'Pix',
        delivery: '22/04/2024',
        type: 'Entrega padrão'
      }
    ],
    processando: [
      {
        id: '12345',
        date: '15/04/2024',
        status: 'processando',
        product: 'Smartphone XYZ Pro',
        price: 'R$ 2.499,00',
        quantity: 1,
        payment: 'Cartão de crédito',
        delivery: '20/04/2024',
        type: 'Entrega expressa'
      }
    ],
    enviados: [
      {
        id: '12346',
        date: '16/04/2024',
        status: 'enviados',
        product: 'Fone Bluetooth',
        price: 'R$ 299,90',
        quantity: 2,
        payment: 'Pix',
        delivery: '22/04/2024',
        type: 'Entrega padrão'
      }
    ],
    entregues: [
      {
        id: '12347',
        date: '10/04/2024',
        status: 'entregues',
        product: 'Smart TV 55"',
        price: 'R$ 3.999,00',
        quantity: 1,
        payment: 'Boleto',
        delivery: '15/04/2024',
        type: 'Entrega expressa'
      }
    ],
    cancelados: []
  };

  const tabs = [
    { id: 'todos', label: 'Todos' },
    { id: 'processando', label: 'Processando' },
    { id: 'enviados', label: 'Enviados' },
    { id: 'entregues', label: 'Entregues' },
    { id: 'cancelados', label: 'Cancelados' },
  ];

  const getStatusColor = (status) => {
    const colors = {
      processando: 'bg-yellow-500',
      enviados: 'bg-blue-500',
      entregues: 'bg-green-500',
      cancelados: 'bg-red-500'
    };
    return colors[status] || 'bg-gray-500';
  };

  return (
    <div className="max-w-7xl mx-auto p-1">
      <header className="mb-8">
        <h1 className="text-2xl font-bold">Meus Pedidos</h1>
        <p className="text-gray-600">Acompanhe e gerencie todos os seus pedidos</p>
      </header>

      <div className="mb-6">
        <div className="flex gap-2 overflow-x-auto">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-2 rounded-lg font-medium ${
                activeTab === tab.id 
                  ? 'bg-gray-100 text-green-600'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="space-y-4">
        {orders[activeTab].length === 0 ? (
          <div className="text-center py-12">
            <XCircle className="mx-auto h-12 w-12 text-gray-400 mb-4" />
            <h3 className="text-lg font-medium">
              {statusMessages[activeTab].title}
            </h3>
            <p className="text-gray-600 mt-1">
              {statusMessages[activeTab].description}
            </p>
          </div>
        ) : (
          orders[activeTab].map((order) => (
            <div key={order.id} className="border rounded-lg p-4">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                <div>
                  <h2 className="font-bold">Pedido #{order.id}</h2>
                  <p className="text-gray-600 text-sm">Realizado em {order.date}</p>
                </div>
                <div className="flex items-center gap-2 mt-2 md:mt-0">
                  <span className={`${getStatusColor(order.status)} text-white px-2 py-1 rounded-full text-sm`}>
                    {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
                  </span>
                  <Link 
                    to="/FollowupSection" /*{`/minha-conta${order.id}`}*/ // Ir pelo id do produto mais tem que implementar ;)
                    className="flex items-center text-black hover:text-green-600 text-sm"
                  >
                    Detalhes
                    <ChevronRight className="h-4 w-4" />
                  </Link>
                </div>
              </div>

              <div className="grid gap-4 md:grid-cols-3">
                <div className="flex items-start gap-3">
                  <div className="h-16 w-16 rounded-md bg-gray-100 flex items-center justify-center">
                    <ShoppingBag className="h-8 w-8 text-gray-400" />
                  </div>
                  <div>
                    <p className="font-medium">{order.product}</p>
                    <p className="text-gray-600 text-sm">{order.price} x {order.quantity}</p>
                  </div>
                </div>
                
                <div className="md:text-center">
                  <p className="text-sm font-medium">Total</p>
                  <p className="font-bold">{order.price}</p>
                  <p className="text-gray-600 text-xs">{order.payment}</p>
                </div>
                
                <div className="md:text-right">
                  <p className="text-sm font-medium">
                    {order.status === 'entregues' ? 'Entregue em' : 'Entrega estimada'}
                  </p>
                  <p className="font-medium">{order.delivery}</p>
                  <p className="text-gray-600 text-xs">{order.type}</p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default MeusPedidos;